import React, {useState} from "react";
import {Box, Card, InputLabel, TextField, Typography} from "@mui/material";
import Grid from '@mui/material/Grid2';
import {handleInputChange} from "../../../../utils/formUtil";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";

export interface SearchCond<SortOrderValue> {
  keyword: string,
  listCount: number,
  sortOrder: SortOrderValue,
}

export interface SearchFormProps<SortOrderValue> {
  label: string
  isLoading: boolean
  searchCond: SearchCond<SortOrderValue>
  onChange: (searchCond: SearchCond<SortOrderValue>) => void
  onSubmit: React.FormEventHandler<HTMLFormElement> | undefined
}

export default function SearchForm<SortOrderValue>(props: SearchFormProps<SortOrderValue>) {
  const [searchCond, setSearchCond] = useState<SearchCond<SortOrderValue>>(props.searchCond);

  return (
    <Card sx={{p: 3}}>
      <Typography variant="subtitle1" sx={{fontWeight: "bold"}}>
        検索条件
      </Typography>
      <Box sx={{ml: 2}}>
        <form onSubmit={props.onSubmit}>
          <InputLabel
            variant="standard"
            sx={{mt: 2, color: "text.primary"}}
          >
            検索キーワード
          </InputLabel>

          <Grid container>
            <Grid size={{xs: 5}}>
              <TextField
                label={props.label}
                name="keyword"
                value={props.searchCond.keyword}
                variant="outlined"
                size="small"
                margin="dense"
                fullWidth
                onChange={(e) => {
                  props.onChange({
                    ...searchCond,
                    keyword: e.target.value,
                  });
                  handleInputChange<SearchCond<SortOrderValue>>(e, searchCond, setSearchCond)
                }
                }
              />
            </Grid>
          </Grid>
          <Box sx={{mt: 1}}>
            <Pjdb1Button
              label="検索"
              variant="contained"
              color="primary"
              isLoading={props.isLoading}
              type='submit'
            />
          </Box>
        </form>
      </Box>
    </Card>
  )
}
